enum OfferDisplayPreference {
  Sell = 'SELL',
  Watch = 'WATCH',
  DontCare = 'DONT_CARE',
}

export default OfferDisplayPreference
